/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserRefreshResponse } from '../entities/UserRefreshResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userRefreshResponseSchema = z.object({
  access_token: z.string(),
}) as unknown as ToZod<UserRefreshResponse>